import { vservice } from '@niknevis/vue-modules'
import { PanelContentItemService } from '@/modules/content-item/services/panel-content-item.service'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { ContentItemResourceType } from '@/modules/content-item/models/content-item-resource.model'

@vservice()
export class ContentItemGetUseCase {
  constructor(
    private readonly service: PanelContentItemService
  ) {
  }

  private remoteData = RemoteData
    .notAsked<ContentItemResourceType>()

  get item() {
    return this.remoteData.fold(
      () => null,
      value => value?.data || null,
      value => value,
      (error, value) => value?.data || null
    )
  }

  get itemWhole() {
    return this.remoteData.fold(
      () => null,
      value => value || null,
      value => value,
      (error, value) => value || null
    )
  }

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  execute(itemId: number): RemoteData<ContentItemResourceType> {
    return this.remoteData.fromPromise(
      this.service.show(itemId)
    )
  }
}
